export const Locales = {
    en: { label: 'English', value: 'en' },
    fr: { label: 'Français', value: 'fr' },
    it: { label: 'Italiano', value: 'it' },
    de: { label: 'Deutsche', value: 'de' },
    es: { label: 'Español', value: 'es' },
}